/* Common for Production Profiles. */
export const data: any = {
  NEXT_PUBLIC_DEPLOYMENT_ENV: "production",
  NEXT_PUBLIC_CF_MXP_ENVIRONMENT: "master", // Contentful MXP Environment
  NEXT_PUBLIC_CF_RC_SPACE_ID: "jnzexz4x7lkk",
  NEXT_PUBLIC_CF_RC_ENVIRONMENT: "master", // Contentful RC Environment
  NEXT_PUBLIC_CF_DATASTORAGE_SPACE_ID: "0hyoy390926j",
  NEXT_PUBLIC_CF_DATASTORAGE_ENV: "master",
  // NEXT_PUBLIC_GTM_ID: "GTM-TPFGGLT",
  NEXT_PUBLIC_PREVIEW_DATA: false, // Important: Should show not show unpublished data in production.
  NEXT_PUBLIC_RENDER_NAV: true, // Render Navigation. We want to not render the nav in preview.
  NEXT_PUBLIC_RENDER_FOOTER: true, // Render Footer. We want to not render the footer in preview.
  // SSG is opt-in: set NEXT_PUBLIC_ENABLE_SSG=true (build env var) to allow
  // any prerendering at all. Without it, all NEXT_PUBLIC_PRERENDER_* flags
  // below are forced to false at runtime (see getProfile.ts), so every page
  // renders on-demand instead of at build time. This keeps build times and
  // Netlify's prerendered-content blob storage from growing unbounded as
  // content volume increases.
  NEXT_PUBLIC_ENABLE_SSG: false,
  NEXT_PUBLIC_PRERENDER_ARTICLES: true, // Prerender Articles. If you have a very large amount of articles you may want to turn this off.
  NEXT_PUBLIC_PRERENDER_CASESTUDIES: true,
  NEXT_PUBLIC_PRERENDER_CUSTOMERSTORIES: true,
  NEXT_PUBLIC_PRERENDER_DOCS: true,
  NEXT_PUBLIC_PRERENDER_VIDEOS: true,
  NEXT_PUBLIC_PRERENDER_EXTERNAL_RESOURCES: true,
  NEXT_PUBLIC_PRERENDER_TAGS: true,
  NEXT_PUBLIC_PRERENDER_COLLECTIONS: true,
  NEXT_PUBLIC_PRERENDER_PAGES: true,
  NEXT_PUBLIC_PRERENDER_TRIMBLE_DEVELOPER: true,
  NEXT_PUBLIC_ALGOLIA_APP_ID: "BGUNL6UMZR",
  NEXT_PUBLIC_ALGOLIA_API_KEY: "d391b07b54d358a1351edb9a348b4a75",
  NEXT_PUBLIC_ALGOLIA_GLOBAL_INDEX: "global-production",
  NEXT_PUBLIC_ALGOLIA_QS_INDEX: "global-production_query_suggestions",
  NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE: 10,
  NEXT_PUBLIC_NINETAILED_CLIENT_ID: "1120e1be-bcc5-4b05-bd8d-589ec716bf97",
  NEXT_PUBLIC_NINETAILED_ENVIRONMENT: "main",
}
